import React, { useState, useEffect } from 'react';

import Checkbox from 'components/shared/Checkbox/Checkbox';

const RadioSelectCell = ({ node, api }) => {
  const [isSelected, setIsSelected] = useState(node.isSelected());

  useEffect(() => {
    const onSelectionChanged = () => {
      setIsSelected(node.isSelected());
    };

    api.addEventListener('selectionChanged', onSelectionChanged);

    return () => {
      api.removeEventListener('selectionChanged', onSelectionChanged);
    };
  }, [api, node]);

  const handleChange = () => {
    node.setSelected(!isSelected);
  };

  return (
    <div className="flex h-full justify-center items-center">
      <Checkbox size={16} id={`select-${node.id}`} label="" rounded isChecked={isSelected} onChange={handleChange} />
    </div>
  );
};

export default RadioSelectCell;
